import React from 'react'
import Layout from '../components/layout'
import Seo from '../components/seo'

import Spacer from '../components/spacer'
import Title from '../components/title'
import FeaturedMedia from '../components/featuredMedia'
import SmallCaption from '../components/smallCaption'
import { graphql } from 'gatsby'
import AboutIntro from '../components/aboutIntro'
import Aspect from '../components/aspect'
import TeamMembers from '../components/teamMembers'

function About({ data }) {
    return (
        <Layout>
            <Seo title='About' />
            <Spacer />
            <Spacer />
            <div className="ma">
                <Title className='' text='about' />
            </div>
            <Spacer className='m-hide' />
            <Spacer />
            <SmallCaption text='Intentionally small (since 2018)' />
            <FeaturedMedia image={data.about.image.gatsbyImageData} ratio={'ratio-2-1 '} video={data.about.video} />
            <Spacer />
            <Spacer className='m-hide' />
            <AboutIntro>
                {data.about.about}
            </AboutIntro>
            <Spacer />
            {data.about.aboutAspects.map((aspect) => {
                return (
                    <>
                        <Aspect aspect={aspect} />
                        <Spacer />
                    </>
                )
            })}
            <Spacer />
            <TeamMembers members={data.members.nodes} />
            <Spacer className='m-hide' />
            <Spacer />
        </Layout>
    )
}

export default About

export const query = graphql`
    query AboutPage{
        members:allDatoCmsCrewMember(sort: {fields: position, order: ASC}) {
            nodes {
              name
              role
              slug
              subrole
              image {
                gatsbyImageData(placeholder:NONE, layout: CONSTRAINED, width: 1200)
              }
            }
          }
        about:datoCmsAbout{
            aboutAspects {
                name
                aspects {
                  text
                  name
                }
              }
            about
            image{
                gatsbyImageData
            }
            video
           
        }
    }
`